import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import getCourseNamesList from 'api/administration/courses/AllCoursesList'

async function getList() {
  return await getCourseNamesList()
}

function* courseNamesListEffectSaga() {
  try {
    const data = yield call(getList)
    yield put(fromActions.Actions.coursesGetNameListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* courseNamesListWatcherSaga() {
  yield takeLatest(fromActions.COURSES_GET_NAME_LIST, courseNamesListEffectSaga)
}
